export const literals = {
  "en": {
    "action": "Action",
    "add": "Add",
    "add_many_cars": "You can add many cars as you want, organize and always have them in your hands.",
    "add_plate": "Add Plate",
    "address": "Address",
    "admin": "Admin",
    "after": "After",
    "agent": "Agent",
    "already_a_member": "Already a Member",
    "amount": "Amount",
    "amount_in_$": "Amount in $",
    "amount_paid": "Amount Paid",
    "api_token": "API Token",
    "api_token_helper": "Inside the Moneris Gateway merchant account, you need to obtain an API Token. Go to My Account and click on the ADMIN. Then click on Store Settings and click on the button to generate an API Token.",
    "applied_from": "Applied From",
    "applied_to": "Applied To",
    "cancel": "Cancel",
    "cant_change_permission": "You can't change your own permission, please contact support",
    "checkout_id": "Checkout ID",
    "cities": "Cities",
    "city": "City",
    "city_added_successfully": "City Added Successfully",
    "city_deleted_successfuly": "City deleted successfuly",
    "city_name": "City Name",
    "city_updated_successfully": "City Updated Successfully",
    "confirm_your_zone": "Confirm Your Zone",
    "current": "Current",
    "customer": "Client",
    "dashboard": "Dashboard",
    "days": "Days",
    "dont_have_an_account": "Don't have an account",
    "email": "Email",
    "email_address": "Email Address",
    "employee": "Employee",
    "enabled_from_to": "Enabled (from - to)",
    "end_date": "End Date",
    "end_date_time": "End Date/Time",
    "end_time": "End time",
    "first_name": "First Name",
    "forgot_password": "Forgot Password",
    "free": "Free",
    "historical": "Historical",
    "history": "History",
    "i_have_read_and_agreed": "I have read and agreed to the Conditions of Use and the Privacy Policy.",
    "identifier": "Identifier",
    "info_get_checkout_id": "To get the checkout ID and start configuring your page, do the following:",
    "info_get_checkout_id_1": "Log into the Merchant Resource Center at one of the following URLs (according to your stage of development)",
    "info_get_checkout_id_2": "In the Admin menu, select Moneris Checkout Config",
    "info_get_checkout_id_3": "Click the Create Profile button",
    "info_get_checkout_id_4": "Follow the on-screen steps to complete the configuration",
    "info_get_checkout_id_pro": "Production",
    "info_get_checkout_id_test": "Testing",
    "info_secret_key_1": "Sign in to your Stripe account.",
    "info_secret_key_2_1": "In your",
    "info_secret_key_2_2": "dashboard",
    "info_secret_key_2_3": "click “Developers”, then “API keys”.",
    "info_secret_key_3": "On the “API keys” page, you can find both your publishable and secret keys under “Standard keys”.",
    "last_name": "Last Name",
    "link": "Link",
    "log_in": "Log in",
    "log_out": "Log out",
    "logo": "Logo",
    "manage_cities": "Manage Cities",
    "manage_modules": "Manage Modules",
    "manage_organizations": "Manage Organizations",
    "manage_permissions": "Manage Permissions",
    "manage_rates": "Manage Rates",
    "manage_tickets": "Manage Tickets",
    "manage_users": "Manage Users",
    "manage_zones": "Manage Zones",
    "module": "Module",
    "module_added_successfully": "Module Added Successfully",
    "module_deleted_successfuly": "Module deleted successfuly",
    "module_name": "Module Name",
    "module_updated_successfully": "Module Updated Successfully",
    "modules": "MODULES",
    "moneris": "Moneris",
    "name": "Name",
    "new_password": "New Password",
    "new_plate": "New Plate",
    "org_added_successfully": "Organization Added Successfully",
    "org_deleted_successfuly": "Organization deleted successfully",
    "org_updated_successfully": "Organization Updated Successfully",
    "organization": "Organization",
    "organization_detail": "Organization Detail",
    "organization_name": "Organization Name",
    "organizations": "ORGANIZATIONS",
    "paid": "Paid",
    "parking": "Parking",
    "parking_history": "Parking History",
    "parking_id": "Parking ID",
    "parking_session_end_at": "Your parking session will end:",
    "parkings": "Parkings",
    "password": "Password",
    "pay_for_parking": "Pay for Parking",
    "payment_gateway": "Payment Gateway",
    "permissions": "Permissions",
    "phone_no": "Phone No",
    "plate": "Plate",
    "please_draw_polygon": "Please Draw Polygon",
    "please_select_cities": "Please select cities",
    "please_upload_logo": "Please Upload Logo",
    "profile": "Profile",
    "profile_updated_successfuly": "Profile Updated Successfuly",
    "publishable_key": "Publishable Key",
    "qr_code": "QR Code",
    "rate": "Rate",
    "rate_added_successfully": "Rate Added Successfully",
    "rate_deleted_successfuly": "Rate deleted successfully",
    "rate_in_cents": "Rate (in cents)",
    "rate_name": "Rate Name",
    "rate_steps": "Rate Steps",
    "rate_type": "Rate Type",
    "rate_updated_successfully": "Rate Updated Successfully",
    "rates": "RATES",
    "regular_rate": "Regular Rate",
    "remember_me": "Remember me",
    "report": "Report",
    "role": "Role",
    "root": "Root",
    "rows_per_page": "Rows Per Page",
    "search": "Search",
    "search_city": "Search City",
    "search_zone": "Search Zone",
    "secret_key": "Secret Key",
    "select_city": "Select City",
    "select_city_zone": "Please select city and zone",
    "select_organization": "Select Organization",
    "select_plate": "Select Plate",
    "select_rate": "Select Rate",
    "select_zone": "Select Zone",
    "send_by_email": "Send by email",
    "service_fee": "Service Fee",
    "service_fee_in_cents": "Service Fee (in cents)",
    "sign_up": "Sign up",
    "special_rate": "Special Rate",
    "start_date": "Start Date",
    "start_date_time": "Start Date/Time",
    "start_time": "Start time",
    "steps": "Steps",
    "store_id": "Store ID",
    "store_id_helper": "Your Store ID is sent to you in the Welcome email when you first sign up for an account with Moneris",
    "stripe": "Stripe",
    "sub_domain": "Sub Domain",
    "theme_color": "Theme Color",
    "ticket_added_successfully": "Ticket Added Successfully",
    "ticket_aging": "Ticket Aging",
    "ticket_deleted_successfuly": "Ticket Deleted Successfully",
    "ticket_name": "Ticket Name",
    "ticket_num_end": "Ticket Number End",
    "ticket_num_next": "Next Ticket Number",
    "ticket_num_start": "Ticket Number Start",
    "ticket_updated_successfully": "Ticket Updated Successfully",
    "tickets": "Tickets",
    "time": "Time",
    "time_in_minutes": "Time (in minutes)",
    "to": "to",
    "total_incl_GST": "Total (incl. Taxes)",
    "unable_to_delete": "Unable to delete.Contact Support",
    "update": "Update",
    "update_password": "Update Password",
    "user": "User",
    "user_detail": "User Detail",
    "user_email": "User Email",
    "user_name": "User Name",
    "users": "USERS",
    "verified": "Verified",
    "web_app": "Web App",
    "welcome": "Welcome",
    "within": "Within",
    "zone": "Zone",
    "zone_added_successfully": "Zone Added Successfully",
    "zone_deleted_successfuly": "Zone deleted successfully",
    "zone_name": "Zone Name",
    "zone_updated_successfully": "Zone Updated Successfully",
    "zones": "ZONES",
    "tickets_issued": "Tickets Issued",
    "ticket_num": "Ticket Number",
    "parking_status": "Parking Status",
    "ticket_status": "Ticket Status",
    "issued_at": "Issued At",
    "unpaid": "Unpaid",
    "expired": "Expired",
    "search_ticket": "Search Ticket",
    "next": "Next",
    "back": "Back",
    "summary": "Summary",
    "payment": "Payment",
    "receipt": "Receipt",
    "already_paid": "Already Paid",
    "ticket_not_found": "Ticket Not Found",
    "ticket_duration": "Ticket Duration",
    "ticket_passed_days": "Ticket Passed Days",
    "pay": "Pay",
    "back_to_home": "Back to home",
    "ticket_pay_receipt": "Ticket Pay Receipt",
    "location": "Location",
    "images": "Images",
    "external_parking_rights": "External Parking Rights",
    "blinkay_ins_id": "Blinkay Installation Id",
    "blinkay_group_id": "Blinkay Group Id",
    "blinkay_tariff_id": "Blinkay Tariff Id",
    "configuration_added_successfully": "Configuration Added Successfully",
    "external_parking_config": "External Parking Configuration",
    "configuration": "Configuration",
    "configuration_deleted_successfully": "Configuration Deleted Successfully",
    "configuration_updated_successfully": "Configuration Updated Successfully",
    "zone_already_configured": "Zone Already Configured",
    "payment_envoirnment": "Payment Environment",
    "live": "Live",
    "test": "Test",
    "tenant_zone": "Tenant Zone",
    "plate_already_exist": "Plate Already Exist",
    "tenant_plates": "Whitelist Plates",
    "manage_tenent_plates": "Manage Whitelist Plates",
    "plate_added_successfully": "Plate Added Successfully",
    "plate_updated_successfully": "Plate Updated Successfully",
    "plate_deleted_successfuly": "Plate Deleted Successfully",
    "reporting": "Reporting",
    "select_org": "Select Organization",
    "operator": "Operator",
    "select_key": "Select Key",
    "and": "AND",
    "or": "OR",
    "filter": "Filter",
    "select_user": "Select User",
    "flat_rate": "Flat Rate",
    "paid_at": "Paid at",
    "add_caption": "Add Caption",
    "caption_en": "Caption (En)",
    "caption_fr": "Caption (Fr)",
    "allow_visitor": "Allow Visitor",
    "unit": "Unit",
    "plate_one": "Plate One",
    "plate_two": "Plate Two",
    "plate_three": "Plate Three",
    "no_of_visitors": "No Of Visitors Allowed",
    "park_visitor": "Park for Visitors",
    "visitor": "Visitor",
    "car_make_one": "Vehicle 1 Car Make",
    "model_one": "Vehicle 1 Model",
    "color_one": "Vehicle 1 Color",
    "car_make_two": "Vehicle 2 Car Make",
    "model_two": "Vehicle 2 Model",
    "color_two": "Vehicle 2 Color",
    "car_make_three": "Vehicle 3 Car Make",
    "model_three": "Vehicle 3 Model",
    "color_three": "Vehicle 3 Color",
    "email_already_exist": "Email Already Exist",
    "manage_residant_plates": "Manage Resident Plates",
    "residant_plates": "Resident Plates",
    "total_incl_tax": "Total (including taxes)",
    "receipt_legal_disclaimer": "Receipt Legal Disclaimer",
    "is_visitor_pass": "Is Visitor Pass",
    "visitor_pass": "Visitor Pass",
    "submit": "Submit",
    "group_by": "Group By",
    "did_not_received_verification_email": "Didn't receive the verification email yet?",
    "enable_parking_limit": "Parking Limit",
    "plate_limit": "Limit per Plate (in minutes)",
    "no_of_parking_per_plate": "No of parkings per plate",
    "reset_parking_limit": "Reset Parking Limit",
    "parking_limit_reset_successfully": "Parking Limit Reset Successfully",
    "save": "Save",
    "issue_ticket": "Issue",
    "search_organization": "Search Organization",
    "no_record_found": "No Record Found",
    "search_plate": "Search Plate",
    "is_business_pass": "Business Pass",
    "no_of_business_pass": "No of Business Pass",
    "business_pass_plates": "Business Pass Plates",
    "manage_business_pass_plates": "Manage Business Pass Plates",
    "end_session": "End Session",
    "session_end_successfully": "Session end successfully",
    "time_zone": "Time Zone",
    "notes": "Notes",
    "total_amount": "Total Amount",
    "privacy_policy": "Privacy Policy",
    "condition_of_use": "Condition of Use",
    "booting": "Booting",
    "normal": "Normal",
    "ticket_type": "Ticket Type",
    "message_after_paid": "Message After Paid",
    "can_user_kick_out": "Can User Kick Out",
    "parking_already_purchased": "Parking is already purchased in this zone",
    "plate_kickout_purchase_now": "Plate kick out successfully, zone is free to park",
    "kick_out": "Kick Out",
    "kick_out_plates": "Kick Out Plates",
    "kick_out_plate": "Kicked Out Plate",
    "kick_out_by": "Kicked Out By",
    "kick_out_at": "Kicked Out At",
    "scan": "Scan",
    "enable_custom_rate": "Enable Custom Rate",
    "custom_rate": "Custom Rate",
    "how_many_days_wants_to_park": "How many days you want to park?",
    "literal_sheet_url": "Literals Sheet URL",
    "whatsapp_no": "Whatsapp No",
    "hide_login_button": "Hide Login Button",
    "select_period_your_stay": "Select Rate",
    "parking_management": "PARKING MANAGEMENT",
    "space_available": "Space Available:",
    "plate_confirmation": "PLATE CONFIRMATION",
    "confirm": "Confirm",
    "plate_no": "Plate Number",
    "plate_not_register_as_employee": "This plate is not registered as an employee Please see your manager",
    "error": "Error",
    "continue": "Continue",
    "registration_successful": "REGISTRATION SUCCESSFUL",
    "plate_registered_successfully": "Your plate has been successfully registered.",
    "no_vehicle_parked": "No vehicle parked at the moment",
    "exit_successful": "EXIT SUCCESSFUL",
    "parking_exit_successfully": "Your parking has been successfully exit.",
    "plate_not_parked": "This plate is not parked at the moment.",
    "check_status": "Check Status",
    "type": "Type",
    "at_end_of_month": "At end of Month",
    "at_end_of_year": "At end of Year",
    "start_parking_limit_date": "Start Parking Limit Date",
    "end_parking_limit_date": "End Parking Limit Date",
    "start_parking_limit_date_must_be_greater": "End Parking Limit Date must be greater than Start Parking Limit Date ",
    "parking_limit_type": "Parking Limit Type",
    "check_out_our_website": "Want to know more about us?",
    "enable_extension": "Enable Extension",
    "ticket_format": "Ticket Format",
    "print": "Print",
    "ticket_print_successfully": "Ticket print successfully",
    "configure": "Configure",
    "is_plate_editable": "Is Plate Editable?",
    "no_of_times_plate_can_edit": "No. of times plate can edit",
    "plate_edit_limit_exceeds": "Plate edit limit exceeds",
    "no_of_times_plate_edited": "No. of times plate edited",
    "edit_plate": "Edit Plate",
    "plate_edited_successfully": "Plate updated successfully",
    "zone_code": "Zone Code",
    "zone_code_already_exists": "Zone Code already exists",
    "park_now": "Park Now",
    "is_whitelist": "Is Whitelist",
    "cannot_park_amount_is_greater_than_0": "Amount is greater than 0, please select another rate",
    "reporting_url": "Reporting Link",
    "google_sheet": "Google Sheet",
    "owner_email": "Owner Email",
    "email_templates": "Email Templates",
    "template_name": "Template Name",
    "template": "Template",
    "subject": "Subject",
    "template_added_successfully": "Template added successfully",
    "template_updated_successfully": "Template updated successfully",
    "template_deleted_successfuly": "Template deleted successfully",
    "virtual_meter_ads": "Virtual Meter Ads",
    "note_added_successfully": "Note added successfully",
    "note_updated_successfully": "Note updated successfully",
    "note_deleted_successfully": "Note deleted successfully",
    "public": "Public",
    "private": "Private",
    "manage_notes": "Manage Notes",
    "note": "Note",
    "public_note": "Public Note",
    "private_note": "Private Note",
    "agent_can_add_custom": "Agent can add custom",
    "custom_public_note": "Custom Public Note",
    "custom_private_note": "Custom Private Note",
    "no_image_found": "Image not found",
  },
  "fr": {
    "action": "Action",
    "add": "Ajouter",
    "add_many_cars": "Vous pouvez ajouter autant de voitures que vous le souhaitez, les organiser et les avoir toujours entre vos mains.",
    "add_plate": "Ajouter une plaque",
    "address": "Adresse",
    "admin": "administrateur",
    "after": "Après",
    "agent": "agent",
    "already_a_member": "Déjà membre",
    "amount": "Montant",
    "amount_in_$": "Montant en $",
    "amount_paid": "Le montant payé",
    "api_token": "Jeton d'API",
    "api_token_helper": "Dans le compte marchand Moneris Gateway, vous devez obtenir un jeton API. Allez dans Mon compte et cliquez sur ADMIN. Cliquez ensuite sur Paramètres du magasin et cliquez sur le bouton pour générer un jeton API.",
    "applied_from": "Appliqué à partir de",
    "applied_to": "Appliqué à",
    "cancel": "Annuler",
    "cant_change_permission": "Vous ne pouvez pas modifier votre propre autorisation, veuillez contacter l'assistance",
    "checkout_id": "ID de paiement",
    "cities": "Villes",
    "city": "Ville",
    "city_added_successfully": "Ville ajoutée avec succès",
    "city_deleted_successfuly": "Ville supprimée avec succès",
    "city_name": "Nom de Ville",
    "city_updated_successfully": "Ville mise à jour avec succès",
    "confirm_your_zone": "Confirmez votre zone",
    "current": "Courant",
    "customer": "client",
    "dashboard": "Tableau de bord",
    "days": "Journées",
    "dont_have_an_account": "Vous n'avez pas de compte ?",
    "email": "E-mail",
    "email_address": "Adresse e-mail",
    "employee": "Employé",
    "enabled_from_to": "Activé (de - à)",
    "end_date": "Date de fin",
    "end_date_time": "Date/heure de fin",
    "end_time": "Heure de fin",
    "first_name": "Prénom",
    "forgot_password": "Mot de passe oublié",
    "free": "Libre",
    "historical": "Historique",
    "history": "Histoire",
    "i_have_read_and_agreed": "J'ai lu et j'accepte les Conditions d'utilisation et la Politique de confidentialité.",
    "identifier": "Identifiant",
    "info_get_checkout_id": "Pour obtenir l'ID de paiement et commencer à configurer votre page, procédez comme suit :",
    "info_get_checkout_id_1": "Connectez-vous au Merchant Resource Center à l'une des URL suivantes (selon votre stade de développement)",
    "info_get_checkout_id_2": "Dans le menu Admin, sélectionnez Moneris Checkout Config",
    "info_get_checkout_id_3": "Cliquez sur le bouton Créer un profil",
    "info_get_checkout_id_4": "Suivez les étapes à l'écran pour terminer la configuration",
    "info_get_checkout_id_pro": "Production",
    "info_get_checkout_id_test": "Essai",
    "info_secret_key_1": "Connectez-vous à votre compte Stripe.",
    "info_secret_key_2_1": "Dans ton",
    "info_secret_key_2_2": "tableau de bord",
    "info_secret_key_2_3": "cliquez sur \"Développeurs\", puis sur \"Clés API\".",
    "info_secret_key_3": "Sur la page \"Clés API\", vous pouvez trouver vos clés publiables et secrètes sous \"Clés standard\".",
    "last_name": "Nom de famille",
    "link": "Lien",
    "log_in": "Connexion",
    "log_out": "Se déconnecter",
    "logo": "Logo",
    "manage_cities": "Gérer les villes",
    "manage_modules": "Gérer les modules",
    "manage_organizations": "Gérer les organisations",
    "manage_permissions": "Gérer les autorisations",
    "manage_rates": "Gérer les tarifs",
    "manage_tickets": "Gérer les billets",
    "manage_users": "gérer les utilisateurs",
    "manage_zones": "Gérer les zones",
    "module": "Module",
    "module_added_successfully": "Module ajouté avec succès",
    "module_deleted_successfuly": "Module supprimé avec succès",
    "module_name": "Nom du module",
    "module_updated_successfully": "Module mis à jour avec succès",
    "modules": "MODULES",
    "moneris": "Monéris",
    "name": "Nom",
    "new_password": "nouveau mot de passe",
    "new_plate": "Nouvelle plaque",
    "org_added_successfully": "Organisation ajoutée avec succès",
    "org_deleted_successfuly": "Organisation supprimée avec succès",
    "org_updated_successfully": "Organisation mise à jour avec succès",
    "organization": "Organisme",
    "organization_detail": "Détail de l'organisation",
    "organization_name": "nom de l'organisation",
    "organizations": "ORGANISATIONS",
    "paid": "Payé",
    "parking": "parking",
    "parking_history": "Historique du stationnement",
    "parking_id": "ID de stationnement",
    "parking_session_end_at": "Votre session de stationnement se terminera :",
    "parkings": "Stationnements",
    "password": "Mot de passe",
    "pay_for_parking": "Payer pour le stationnement",
    "payment_gateway": "Passerelle de paiement",
    "permissions": "Autorisations",
    "phone_no": "Numéro de téléphone",
    "plate": "Plaque",
    "please_draw_polygon": "Veuillez dessiner un polygone",
    "please_select_cities": "Veuillez sélectionner des villes",
    "please_upload_logo": "Veuillez télécharger le logo",
    "profile": "Profil",
    "profile_updated_successfuly": "Profil mis à jour avec succès",
    "publishable_key": "Clé publiable",
    "qr_code": "QR Code",
    "rate": "Évaluer",
    "rate_added_successfully": "Tarif ajouté avec succès",
    "rate_deleted_successfuly": "Taux supprimé avec succès",
    "rate_in_cents": "Taux (en cents)",
    "rate_name": "Nom du tarif",
    "rate_steps": "Échelons de taux",
    "rate_type": "Type de taux",
    "rate_updated_successfully": "Taux mis à jour avec succès",
    "rates": "LES TAUX",
    "regular_rate": "Tarif régulier",
    "remember_me": "Souviens-toi de moi",
    "report": "Signaler",
    "role": "Rôle",
    "root": "Racine",
    "rows_per_page": "Lignes par page",
    "search": "Chercher",
    "search_city": "Rechercher une ville",
    "search_zone": "Zone de recherche",
    "secret_key": "Clef secrète",
    "select_city": "Sélectionnez une ville",
    "select_city_zone": "Veuillez sélectionner la ville et la zone",
    "select_organization": "Sélectionnez l'organisation",
    "select_plate": "Sélectionner la plaque",
    "select_rate": "Sélectionnez le tarif",
    "select_zone": "Sélectionnez Zone",
    "send_by_email": "Envoyé par email",
    "service_fee": "Frais de service",
    "service_fee_in_cents": "Frais de service (en cents)",
    "sign_up": "S'inscrire",
    "special_rate": "Tarif spécial",
    "start_date": "Date de début",
    "start_date_time": "Date/heure de début",
    "start_time": "Heure de début",
    "steps": "Pas",
    "store_id": "Identifiant du magasin",
    "store_id_helper": "Votre ID de magasin vous est envoyé dans le courriel de bienvenue lorsque vous ouvrez un compte chez Moneris pour la première fois.",
    "stripe": "Bande",
    "sub_domain": "Sous-domaine",
    "theme_color": "Couleur du thème",
    "ticket_added_successfully": "Billet ajouté avec succès",
    "ticket_aging": "Vieillissement des billets",
    "ticket_deleted_successfuly": "Ticket supprimé avec succès",
    "ticket_name": "Nom du billet",
    "ticket_num_end": "Fin du numéro de billet",
    "ticket_num_next": "Prochain numéro de billet",
    "ticket_num_start": "Début du numéro de billet",
    "ticket_updated_successfully": "Ticket mis à jour avec succès",
    "tickets": "des billets",
    "time": "Temps",
    "time_in_minutes": "Temps (en minutes)",
    "to": "à",
    "total_incl_GST": "Total (taxes comprises)",
    "unable_to_delete": "Impossible de supprimer. Contactez le support",
    "update": "Mise à jour",
    "update_password": "Mettre à jour le mot de passe",
    "user": "utilisateur",
    "user_detail": "Détails de l'utilisateur",
    "user_email": "Courriel de l'utilisateur",
    "user_name": "Nom d'utilisateur",
    "users": "UTILISATEURS",
    "verified": "Vérifié",
    "web_app": "Application Web",
    "welcome": "Bienvenu",
    "within": "Dans",
    "zone": "Zone",
    "zone_added_successfully": "Zone ajoutée avec succès",
    "zone_deleted_successfuly": "Zone supprimée avec succès",
    "zone_name": "Nom de zone",
    "zone_updated_successfully": "Zone mise à jour avec succès",
    "zones": "Zones",
    "tickets_issued": "Billets émis",
    "ticket_num": "Numéro de billet",
    "parking_status": "Statut de stationnement",
    "ticket_status": "Statut du ticket",
    "issued_at": "Émis à",
    "unpaid": "Non payé",
    "expired": "Expired",
    "search_ticket": "Rechercher un billet",
    "next": "Prochain",
    "back": "Retour",
    "summary": "Sommaire",
    "payment": "Paiement",
    "receipt": "Reçu",
    "already_paid": "Déjà payé",
    "ticket_not_found": "Billet introuvable",
    "ticket_duration": "Durée du billet",
    "ticket_passed_days": "Billet Passé Jours",
    "pay": "Payer",
    "back_to_home": "De retour à la maison",
    "ticket_pay_receipt": "Reçu de paiement du billet",
    "location": "Emplacement",
    "images": "Images",
    "external_parking_rights": "Droits de stationnement extérieur",
    "blinkay_ins_id": "Identifiant d'installation Blinkay",
    "blinkay_group_id": "Identifiant de groupe Blinkay",
    "blinkay_tariff_id": "Identifiant tarifaire Blinkay",
    "configuration_added_successfully": "Configuration ajoutée avec succès",
    "external_parking_config": "Configuration de stationnement externe",
    "configuration": "Configuration",
    "configuration_deleted_successfully": "Configuration supprimée avec succès",
    "configuration_updated_successfully": "Configuration mise à jour avec succès",
    "zone_already_configured": "Zone déjà configurée",
    "payment_envoirnment": "Environnement de paiement",
    "live": "Vivre",
    "test": "Test",
    "tenant_zone": "Zone Locataire",
    "plate_already_exist": "La plaque existe déjà",
    "tenant_plates": "Plaques de locataire",
    "manage_tenent_plates": "Gérer les plaques de locataire",
    "plate_added_successfully": "Plaque ajoutée avec succès",
    "plate_updated_successfully": "Plaque mise à jour avec succès",
    "plate_deleted_successfuly": "Plaque supprimée avec succès",
    "reporting": "Rapports",
    "select_org": "Sélectionnez l'organisation",
    "operator": "Opérateur",
    "select_key": "Sélectionnez la clé",
    "and": "ET",
    "or": "OU",
    "filter": "Filtre",
    "select_user": "Sélectionnez l'utilisateur",
    "flat_rate": "Forfait",
    "paid_at": "Payé à",
    "add_caption": "Ajouter une légende",
    "caption_en": "Légende (Fr)",
    "caption_fr": "Légende (Fr)",
    "allow_visitor": "Autoriser le visiteur",
    "unit": "Unité",
    "plate_one": "Assiette 1",
    "plate_two": "Planche deux",
    "plate_three": "Planche trois",
    "no_of_visitors": "Nombre de visiteurs autorisés",
    "park_visitor": "Parc pour les visiteurs",
    "visitor": "Visiteur",
    "car_make_one": "Véhicule 1 Marque de voiture",
    "model_one": "Modèle de véhicule 1",
    "color_one": "Véhicule 1 couleur",
    "car_make_two": "Véhicule 2 Marque de voiture",
    "model_two": "Modèle de véhicule 2",
    "color_two": "Véhicule 2 Couleur",
    "car_make_three": "Véhicule 3 Marque de voiture",
    "model_three": "Modèle de véhicule 3",
    "color_three": "Véhicule 3 couleurs",
    "email_already_exist": "L'e-mail existe déjà",
    "manage_residant_plates": "Gérer les plaques de résident",
    "residant_plates": "Plaques de résident",
    "total_incl_tax": "Total (incluant les taxes)",
    "receipt_legal_disclaimer": "Mentions légales concernant les reçus",
    "is_visitor_pass": "Est-ce un pass visiteur",
    "visitor_pass": "Pass visiteur",
    "submit": "Soumettre",
    "group_by": "Par groupe",
    "did_not_received_verification_email": "Vous n'avez pas encore reçu l'e-mail de vérification ?",
    "enable_parking_limit": "Limite de stationnement",
    "plate_limit": "Limite par plaque (en minutes)",
    "no_of_parking_per_plate": "Nombre de droits de stationnement par plaque",
    "reset_parking_limit": "Réinitialiser la limite de stationnement",
    "parking_limit_reset_successfully": "Réinitialisation de la limite de stationnement réussie",
    "save": "Sauvegarder",
    "issue_ticket": "Émettre",
    "search_organization": "Rechercher l'organisation",
    "no_record_found": "Aucun enregistrement trouvé",
    "search_plate": "Recherche de la plaque",
    "is_business_pass": "Droit de stationnement pour entreprises",
    "no_of_business_pass": "Nombre de droits de stationnement pour votre entreprise",
    "business_pass_plates": "Plaques de droit de stationnement pour entreprises",
    "manage_business_pass_plates": "Gérer les plaques des entreprises",
    "end_session": "Fin de la session",
    "session_end_successfully": "La session se termine avec succès",
    "time_zone": "Zone horaire",
    "notes": "Notes",
    "total_amount": "Montant total",
    "privacy_policy": "Politique de confidentialité",
    "condition_of_use": "Conditions d'utilisation",
    "booting": "Immobilisation",
    "normal": "Normal",
    "ticket_type": "Type de contravention",
    "message_after_paid": "Message après paiement",
    "can_user_kick_out": "L'utilisateur peut-il se retirer",
    "parking_already_purchased": "Le stationnement est déjà acheté dans cette zone",
    "plate_kickout_purchase_now": "La plaque est retirée avec succès, la zone est libre pour le stationnement.",
    "kick_out": "Retirer",
    "kick_out_plates": "Retirer les plaques",
    "kick_out_plate": "Retirer la plaque",
    "kick_out_by": "Retiré par",
    "kick_out_at": "Retiré à",
    "scan": "Scanner",
    "enable_custom_rate": "Activer le taux personnalisé",
    "custom_rate": "Taux personnalisé",
    "how_many_days_wants_to_park": "Combien de jours voulez-vous stationner ?",
    "literal_sheet_url": "Feuille littérale URL",
    "whatsapp_no": "Whatsapp N° de tél.",
    "hide_login_button": "Cacher le bouton de connexion",
    "select_period_your_stay": "Sélectionner le taux",
    "parking_management": "GESTION DU STATIONNEMENT",
    "space_available": "Espace disponible :",
    "plate_confirmation": "CONFIRMATION DE LA PLAQUE",
    "confirm": "Confirmer",
    "plate_no": "Numéro de plaque",
    "plate_not_register_as_employee": "Cette plaque n'est pas enregistrée en tant qu'employé Veuillez consulter votre gestionnaire",
    "error": "Erreur",
    "continue": "Continuer",
    "registration_successful": "ENREGISTREMENT RÉUSSI",
    "plate_registered_successfully": "Votre plaque a été enregistrée avec succès.",
    "no_vehicle_parked": "Pas de véhicule stationné pour le moment",
    "exit_successful": "SORTIR AVEC SUCCÈS",
    "parking_exit_successfully": "La plaque de stationnement a été retirée.",
    "plate_not_parked": "Cette plaque n'est pas stationnée pour le moment.",
    "check_status": "Vérifier le statut",
    "type": "Type",
    "at_end_of_month": "A la fin du mois",
    "at_end_of_year": "En fin d'année",
    "start_parking_limit_date": "Début Limite de stationnement Date",
    "end_parking_limit_date": "Date de fin de la limite de stationnement",
    "start_parking_limit_date_must_be_greater": "La date de fin de la limite de stationnement doit être supérieure à la date de début de la limite de stationnement.",
    "parking_limit_type": "Type de limite de stationnement",
    "check_out_our_website": "Consultez notre site web",
    "enable_extension": "Enable Extension",
    "ticket_format": "Format du ticket",
    "print": "Imprimer",
    "ticket_print_successfully": "Le ticket a été imprimé avec succès",
    "configure": "Configurer",
    "is_plate_editable": "La plaque est-elle modifiable ?",
    "no_of_times_plate_can_edit": "Nombre de fois que la plaque peut être modifiée",
    "plate_edit_limit_exceeds": "Limite de modification de la plaque dépassée",
    "no_of_times_plate_edited": "Nombre de modifications effectuées sur la plaque",
    "edit_plate": "Modifier la plaque",
    "plate_edited_successfully": "Plaque mise à jour avec succès",
    "zone_code": "Code de zone",
    "zone_code_already_exists": "Le code de zone existe déjà",
    "park_now": "Se garer maintenant",
    "is_whitelist": "Est sur liste blanche",
    "cannot_park_amount_is_greater_than_0": "Le montant est supérieur à 0, veuillez sélectionner un autre tarif",
    "reporting_url": "Lien de rapport",
    "google_sheet": "Feuille Google",
    "owner_email": "E-mail du propriétaire",
    "email_templates": "Modèles d'e-mail",
    "template_name": "Nom du modèle",
    "template": "Modèle",
    "subject": "Sujet",
    "template_added_successfully": "Modèle ajouté avec succès",
    "template_updated_successfully": "Modèle mis à jour avec succès",
    "template_deleted_successfuly": "Modèle supprimé avec succès",
    "virtual_meter_ads": "Publicités de compteur virtuel",
    "note_added_successfully": "Note added successfully",
    "note_updated_successfully": "Note updated successfully",
    "note_deleted_successfully": "Note deleted successfully",
    "public": "Public",
    "private": "Private",
    "manage_notes": "Manage Notes",
    "note": "Note",
    "public_note": "Public Note",
    "private_note": "Private Note",
    "agent_can_add_custom": "Agent can add custom",
    "custom_public_note": "Custom Public Note",
    "custom_private_note": "Custom Private Note",
    "no_image_found": "Image not found",
  }
}